<template>
  <v-main class="main d-flex align-center">
    <v-container>
      <v-dialog
        v-model="dialogLoading"
        hide-overlay
        persistent
        width="300"
        v-if="loadingPage"
      >
        <v-card color="primary" dark>
          <v-card-text>
            Cargando...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout v-else class="d-flex justify-start">
        <v-flex xs12 sm4 md4>
          <v-card>
            <v-card-text>
              <h3 class="d-flex justify-center mt-10 mb-2">
                INGRESE SUS DATOS
              </h3>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  prepend-icon="mdi-email"
                  @click:prepend="requestCode"
                  :loading="loadingRequestCode"
                  v-model="email"
                  :rules="rulesEmail"
                  label="Email"
                />
                <v-text-field
                  prepend-icon="mdi-lock"
                  v-model="password"
                  :rules="rulesPassword"
                  label="Password"
                  type="password"
                />

                <v-btn
                  color="primary"
                  block
                  @click="login"
                  class="mt-3 mb-5"
                  :loading="loadingForm"
                  >ACEPTAR</v-btn
                >
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { mixinForm, mixinUser } from "../mixins";

export default {
  mixins: [mixinForm, mixinUser],

  data() {
    return {
      loadingPage: true,
      dialogLoading: true,
      loadingRequestCode: false,
    };
  },

  methods: {
    login() {
      if (!this.valid) this.$refs.form.validate();
      else {
        this.loadingForm = true;
        this.$store
          .dispatch("login", {
            email: this.email,
            password: this.password,
          })
          .then(() => {
            this.$router.push("/dashboard");
            this.loadingForm = false;
          })
          .catch((error) => {
            console.log(error);
            this.$router.push("/");
            this.loadingForm = false;
          });
      }
    },

    requestCode() {
      if (this.email) {
        this.loadingRequestCode = true;
        setTimeout(() => {
          this.$store
            .dispatch("requestCodeAction", this.email)
            .then(() => {
              this.loadingRequestCode = false;
            })
            .catch(() => {
              this.loadingRequestCode = false;
            });
        }, 500);
      }
    },
  },

  beforeMount() {
    setTimeout(() => {
      if (localStorage.getItem("access_token") != null) {
        this.$router.push("/dashboard");
      } else {
        this.loadingPage = false;
        this.dialogLoagind = false;
      }
    }, 1000);
  },
};
</script>

<style scoped>
.main {
  background: url("../assets/background.webp") no-repeat center center;
  min-height: 100%;
  background-size: cover;
}
</style>
